var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2CellEmbryo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 23,
    viewBox: "0 0 17 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9433 7.21696C16.9489 3.26287 13.1736 0.0522142 8.51093 0.0457428C3.84828 0.0392715 0.0639508 3.23944 0.0583966 7.19352C0.0528424 11.1476 3.82816 14.3583 8.49081 14.3647C13.1535 14.3712 16.9378 11.171 16.9433 7.21696Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8377 7.21699C16.8432 3.3243 13.1164 0.163486 8.51379 0.157098C3.91114 0.15071 0.175525 3.30117 0.170057 7.19386C0.164589 11.0865 3.89134 14.2474 8.49398 14.2538C13.0966 14.2601 16.8322 11.1097 16.8377 7.21699Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9336 15.8049C16.9391 11.8508 13.1638 8.64011 8.50116 8.63364C3.83851 8.62717 0.0541852 11.8273 0.048631 15.7814C0.0430768 19.7355 3.8184 22.9462 8.48105 22.9526C13.1437 22.9591 16.928 19.7589 16.9336 15.8049Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.825 15.8049C16.8305 11.9122 13.1037 8.75138 8.50109 8.74499C3.89844 8.7386 0.162829 11.8891 0.157362 15.7818C0.151894 19.6744 3.87864 22.8353 8.48129 22.8416C13.0839 22.848 16.8195 19.6976 16.825 15.8049Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96912 13.3249C9.9702 12.6425 9.34588 12.0883 8.57465 12.0871C7.80342 12.0859 7.17735 12.6381 7.17627 13.3206C7.17519 14.003 7.79952 14.5571 8.57074 14.5583C9.34197 14.5595 9.96804 14.0073 9.96912 13.3249Z",
    fill: "#B3B3B3",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.97547 5.38741C9.97655 4.70501 9.35222 4.15083 8.581 4.14963C7.80977 4.14843 7.1837 4.70065 7.18262 5.38305C7.18154 6.06546 7.80587 6.61963 8.57709 6.62083C9.34832 6.62204 9.97439 6.06982 9.97547 5.38741Z",
    fill: "#B3B3B3",
    stroke: "black",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2CellEmbryo);
export default __webpack_public_path__ + "static/media/2cellEmbryo.3408d638c447f8d4aeb2239291d18dff.svg";
export { ForwardRef as ReactComponent };